import { useState, useRef, useEffect } from 'react'
import Select from 'react-select'
import { useSelector, useDispatch } from 'react-redux'
import { itemsFetchData } from '../../redux/items'
import DropdownToggle from './DropdownToggle'
import { parseSubjectsFromUrl } from '../../SearchUtils'
import CityFilter from './CityFilter'

function CountryFilter({ countries }) {
  const { currentFilters } = useSelector((state) => state.items)
  const dispatch = useDispatch()

  const [selectedCountry, setSelectedCountry] = useState(null)
  const [isCountryUs, setIsCountryUs] = useState(false)
  const [loadingStates, setLoadingStates] = useState(false)
  const [usStates, setUsStates] = useState(null)
  const [selectedState, setSelectedState] = useState(false)
  const [selectedCity, setSelectedCity] = useState(null)
  const [cities, setCities] = useState(null)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const dropdownToggleEl = document.getElementById(
      'dropdown-filter-country'
    )
    dropdownRef.current = new bootstrap.Dropdown(dropdownToggleEl)
  }, [])

  const handleSubmit = () => {
    const newFilters = {
      popstate: 0,
      subjects: parseSubjectsFromUrl(),
      ...currentFilters,
    }

    if (selectedCity) {
      newFilters.state = newFilters.state || []
      newFilters.city = newFilters.city || []

      newFilters.city = [
        ...newFilters.city,
        selectedCity.value
      ]
    }

    if (selectedState) {
      newFilters.country = newFilters.country || []
      newFilters.state = newFilters.state || []

      if (!newFilters.state.includes(selectedState.value)) {
        newFilters.state = [
          ...newFilters.state,
          selectedState.value,
        ]
      }
    } else if (selectedCountry) {
      newFilters.country = newFilters.country || []
      if (!newFilters.country.includes(selectedCountry.value)) {
        newFilters.country = [
          ...newFilters.country,
          selectedCountry.value,
        ]
      }
    }

    delete newFilters.page

    setSelectedState(null)
    setSelectedCountry(null)
    setSelectedCity(null)

    dropdownRef.current.toggle()

    dispatch(itemsFetchData({ filters: newFilters }))
  }

  const selectState = (e) => {
    setSelectedState(e)
    setSelectedCity(null)
  }

  useEffect(() => {
    if (selectedState) {
      fetchCities()
    }
  }, [selectedState])

  const selectCity = (e) => {
    setSelectedCity(e)
  }

  const changeCountry = (country) => {
    setSelectedCountry(country)

    if (country.value === 'US') {
      setIsCountryUs(true)
      setSelectedCountry(country)
      setLoadingStates(true)

      App.Request.get('/addresses/state_select_options.json', {
        params: {
          with_count: 1,
          published_zero_desc: 1,
        },
      }).then(({ status, data }) => {
        if (status === 200) {
          setUsStates(data.states || [])
          setLoadingStates(false)
        }
      })
    } else {
      setIsCountryUs(false)
      setSelectedState(false)
      setSelectedCity(null)
    }
  }

  const fetchCities = () => {
    App.Request.get('/cities/city_select_options.json', {
      params: {
        with_count: 1,
        published_zero_desc: 1,
        country: selectedCountry.value,
        state: selectedState.value
      },
    }).then(({ status, data }) => {
      if (status === 200) {
        setCities(data.cities || [])
      }
    })
  }

  return (
    <div className="dropdown d-block">
      <DropdownToggle
        name="country"
        title={I18n.t('search.filters.location.title')}
      />
      <div
        className="dropdown-menu w-100 p-2"
        id="dropdown-menu-filter-country"
        aria-labelledby="filter-country"
      >
        <form>
          <div className="mb-3">
            <label htmlFor="country">
              {I18n.t('search.filters.location.title')}
            </label>
            <Select
              inputId="country"
              inputProps={{ type: 'text' }}
              options={countries}
              onChange={changeCountry}
              value={selectedCountry}
              placeholder={`${I18n.t('select')}...`}
            />
          </div>
          { isCountryUs &&
            <>
              <div className="mb-3">
                <label htmlFor="region">
                  State
                </label>
                <Select
                  inputId="region"
                  inputProps={{ type: 'text' }}
                  options={usStates}
                  isDisabled={loadingStates}
                  value={selectedState}
                  onChange={(e) => selectState(e)}
                  placeholder={`${I18n.t('select')}...`}
                />
              </div>
              {selectedState &&
                <div className="mb-3">
                  <label htmlFor="city">
                    City
                  </label>
                  <Select
                    inputId="city"
                    inputProps={{ type: 'text' }}
                    options={cities}
                    value={selectedCity}
                    onChange={(e) => selectCity(e)}
                    placeholder={`${I18n.t('select')}...`}
                  />
                </div>
              }
            </>
          }
          <button
            className="btn btn-primary d-block mt-2 w-100"
            type="button"
            onClick={handleSubmit}
          >
            {I18n.t('submit')}
          </button>
        </form>
      </div>
    </div>
  )
}

export default CountryFilter
